const INIT_USERS = [
    {
        id: '17',
        name: 'Aiman',
        username: 'Aiman99',
        password: 'aiman99',
        bookings: [
            {
                id: '69',
            },
        ],
    },
    {
        id: '19',
        name: 'Arya',
        username: 'Arya99',
        password: 'arya99',
        bookings: [
            {
                id: '',
            },
        ],
    },
];

export default INIT_USERS;
